__webpack_require__.p = "/shared-mailboxes-allow-for-send-later/referrals-hub/";